export const FLOOR_LIGHT: BABYLON.Color3 = new BABYLON.Color3(0.99, 0.99, 0.99);
export const FLOOR_MIDDLE: BABYLON.Color3 = new BABYLON.Color3(0.69, 0.69, 0.69);
export const FLOOR_DARK: BABYLON.Color3 = new BABYLON.Color3(0.31, 0.31, 0.31);

export const FLOOR_MAX_METER: number = 50;
export const FLOOR_MAX_FEET: number = 160;
export const FLOOR_METER_IN_FEET: number = .3048;

export const FLOOR_IMAGE_MAXSIZE: number = 25000000; // maximum bytes of opened image-files (loading of big files may freeze/break app)
export const FLOOR_IMAGE_MAXHEIGHT: number = 4500; // maximum height in pixel
export const FLOOR_IMAGE_MAXWIDTH: number = 4500; // maximum width in pixel


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/FloorConstants.ts